export const PriorityConverter: { [key: number]: string } = {
  1: '1st Priority',
  2: '2nd Priority',
  3: '3rd Priority',
  4: '4th Priority',
  5: '5th Priority',
  6: '6th Priority',
};
